export default "__VITE_ASSET__CXiqwq3l__"